<template lang="pug">
  .wrap
    h1 How we did this work?
    p Transition is a digital project of the newspaper La Tercera (and its brand, Qué Pasa) that started its development in July 2018. A group of 16 professional from different teams of our media (digital, video, design, infographics, photography, etc.) worked during four months under the coordination of Tania Opazo, the investigative journalist of this feature.
    p At the end of October, when the feature was close to its release, with the support of the Branded Content Team of the newspaper, Transition got the sponsorship of the telecommunications company, Wom, that bet to this journalistic project completely respecting its editorial independence. Transition became then in the first digital product, 100% editorial, on getting the funding of a private company for its realization.

</template>
<script>
export default {
}
</script>
<style lang="scss" scoped>
  .wrap{
    text-align: center;
    padding: 2rem 1rem;
    max-width: $maxwidth;
    margin-left: auto;
    margin-right: auto;
  }

</style>


